/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../_redux/countries/countriesActions";
import { useCountriesUIContext } from "../CountriesUIContext";

export function CountriesDeleteDialog({ show, onHide }) {
  // Countries UI Context
  const countriesUIContext = useCountriesUIContext();
  const countriesUIProps = useMemo(() => {
    return {
      ids: countriesUIContext.ids,
      setIds: countriesUIContext.setIds,
      queryParams: countriesUIContext.queryParams,
    };
  }, [countriesUIContext]);

  // Countries Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.countries.actionsLoading }),
    shallowEqual
  );

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  // if there weren't selected countries we should close modal
  useEffect(() => {
    if (!countriesUIProps.ids || countriesUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countriesUIProps.ids]);

  const deleteCountries = () => {
    // server request for deleting country by selected ids
    dispatch(actions.deleteCountries(countriesUIProps.ids)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchCountries(countriesUIProps.queryParams)).then(() => {
        // clear selections list
        countriesUIProps.setIds([]);
        // closing delete modal
        onHide();
      });
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      aria-labelledby="delete-countries-modal-title"
    >
      {isLoading && <ModalProgressBar />}
      <Modal.Header closeButton className="py-4 px-6">
        <Modal.Title id="delete-countries-modal-title" className="font-weight-bolder text-dark">
          Delete Selected Countries
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4 px-6">
        <div className="d-flex align-items-center">
          <div className="mr-4">
            <span className="label label-xl label-light-danger label-inline p-4" style={{ borderRadius: "50%" }}>
              <i className="fa fa-exclamation-triangle text-danger font-size-h4"></i>
            </span>
          </div>
          <div>
            <h6 className="font-weight-bolder text-dark mb-1">Confirm Deletion</h6>
            <p className="text-muted mb-0 font-size-sm">
              Are you sure you want to permanently delete{" "}
              <strong className="text-danger font-weight-bolder">
                {countriesUIProps.ids.length} selected countries
              </strong>
              ? This action cannot be undone.
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="py-3 px-6">
        <button
          type="button"
          onClick={onHide}
          className="btn btn-light font-weight-bold"
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={deleteCountries}
          className="btn btn-danger font-weight-bold"
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <i className="fa fa-circle-notch fa-spin mr-1"></i> Deleting...
            </>
          ) : (
            "Delete Countries"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
